import { render, staticRenderFns } from "./NoDataRVS.vue?vue&type=template&id=e05004d4&scoped=true"
import script from "./NoDataRVS.vue?vue&type=script&lang=ts"
export * from "./NoDataRVS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05004d4",
  null
  
)

export default component.exports